import type CSS from 'csstype';
import TextButton from '@components/Button/TextButton';
import Link from '@components/Link';
import type NewsletterCardApi from '@interfaces/NewsletterCardApi';
import I18n from '@components/I18n';

interface Props extends NewsletterCardApi {
    className?: string;
}

export default function NewsletterCard(props: Props) {
    const priceStyle: CSS.Properties = {
        color: props.color,
    };

    const lineStyle: CSS.Properties = {
        background: props.color,
    };

    return (
        <div className={`newsletter-card ${props.className ?? ''} js-track-newsletter-card`}>
            <Link to={`/subscribe/${props.code}/`} className="newsletter-card__link">
                <div className="newsletter-card__pad">
                    <div className="newsletter-card__body">
                        <div className="newsletter-card__line" style={lineStyle} />
                        <div className="newsletter-card__title">{props.title}</div>
                        {props.isPaid ? (
                            <div className="newsletter-card__price" style={priceStyle}>
                                <I18n code="NewsletterCard_club" />
                            </div>
                        ) : null}
                    </div>
                    <TextButton type="button" className="button-text--left" colorModifier="grey">
                        <I18n code="NewsletterCard_more" />
                    </TextButton>
                </div>
            </Link>
        </div>
    );
}
